import { createSelector } from "reselect";
import { State } from "../../../redux/state";
import { WebForm } from "../interfaces/api/get-web-form";
import { dedupeContactFormResponses } from "../utils/formRender.utils";

export const webFormRoot = (state: State) => state.webForm;

export const webFormsSelector = createSelector(webFormRoot, (me) =>
  me.webForms.ids
    .map((id) => me.webForms.entities[id])
    .filter((form): form is WebForm => Boolean(form))
);
export const webFormResponseSelector = createSelector(
  webFormRoot,
  (me) => dedupeContactFormResponses(me.webFormResponses)
);
export const webFormSelector = createSelector(webFormRoot, (me) => me.webForm);

export const webFormFormSelector = createSelector(
  webFormSelector,
  (webForm) => webForm.form
);

export const webFormInputsSelector = createSelector(
  webFormSelector,
  (webForm) => webForm.inputs
);
